import { render, staticRenderFns } from "./InboxMenu.vue?vue&type=template&id=cedb5aea&scoped=true"
import script from "./InboxMenu.vue?vue&type=script&lang=js"
export * from "./InboxMenu.vue?vue&type=script&lang=js"
import style0 from "./InboxMenu.vue?vue&type=style&index=0&id=cedb5aea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedb5aea",
  null
  
)

export default component.exports